import {isBoolean, isEqualWith} from "lodash-es"

export enum ProfilePage {
  Main,
  Captain,
  Common,
  Dimensions,
  Tracking
}

export type TProfilePageProps = {
  page: ProfilePage
  setPage: (page: ProfilePage) => void
  close: () => void
  isShow: boolean
}

export const isInfoEqual = <T extends {[key: string]: any}>(values1: T, values2: T) =>
  isEqualWith(values1, values2, (val1, val2) => {
    if (!val1 && !val2 && !isBoolean(val1) && !isBoolean(val2)) {
      return true
    }
  })
